module.exports = __webpack_public_path__ + "static/Run Paper Scissors.ba83f20f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/feature-graphics/Run Paper Scissors.png
// module id = 474
// module chunks = 35783957827783